import { buildPaymentHistoryRows, formatPlanDate, formatUsd } from '../installmentFormat'

const STATUS_STYLES = {
  succeeded: 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-800 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800',
  failed: 'bg-rose-50 dark:bg-rose-900/30 text-rose-700 dark:text-rose-400 border-rose-200 dark:border-rose-800',
  processing: 'bg-amber-50 dark:bg-amber-900/30 text-amber-800 dark:text-amber-400 border-amber-200 dark:border-amber-800',
  scheduled: 'bg-sky-50 dark:bg-sky-900/30 text-sky-800 dark:text-sky-300 border-sky-200 dark:border-sky-800',
  upcoming: 'bg-slate-100 dark:bg-slate-700/50 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-600'
}

const DOT_STYLES = {
  succeeded: 'bg-emerald-500',
  failed: 'bg-rose-500',
  processing: 'bg-amber-500',
  scheduled: 'bg-sky-500',
  upcoming: 'bg-slate-400'
}

export default function PaymentHistory ({ schedule, charges }) {
  const rows = buildPaymentHistoryRows(schedule, charges)
  if (!rows.length) {
    return (
      <div className='rounded-2xl border border-dashed border-gray-200 dark:border-slate-700 px-4 py-8 text-center text-sm text-slate-500'>
        No scheduled payments on this plan yet.
      </div>
    )
  }
  return (
    <ol className='relative'>
      {rows.map((row, index) => (
        <li key={row.key} className='relative flex gap-4 pb-6 last:pb-0'>
          {index < rows.length - 1 && (
            <span className='absolute left-[7px] top-4 bottom-0 w-px bg-gray-200 dark:bg-slate-700' aria-hidden />
          )}
          <span className={`relative z-10 mt-1.5 w-4 h-4 rounded-full ring-4 ring-white dark:ring-slate-900 ${DOT_STYLES[row.status] || DOT_STYLES.upcoming}`} aria-hidden />
          <div className='flex-1 min-w-0 rounded-2xl border border-gray-100 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2'>
            <div className='min-w-0'>
              <p className='text-sm font-semibold text-slate-900 dark:text-white'>Payment {row.sequence}</p>
              <p className='text-xs text-slate-500 dark:text-slate-400'>
                Due {formatPlanDate(row.date)}
                {row.attemptedAt ? ` · Attempted ${formatPlanDate(row.attemptedAt)}` : ''}
              </p>
              {row.responseText ? <p className='text-xs text-slate-500 mt-1'>{row.responseText}</p> : null}
            </div>
            <div className='flex items-center gap-3 shrink-0'>
              <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold border capitalize ${STATUS_STYLES[row.status] || STATUS_STYLES.upcoming}`}>
                {row.status}
              </span>
              <span className='text-sm font-semibold text-slate-900 dark:text-white tabular-nums'>{formatUsd(row.amount)}</span>
            </div>
          </div>
        </li>
      ))}
    </ol>
  )
}
